"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./Fincore.css");

var _react = _interopRequireDefault(require("react"));

var _mobxReact = require("mobx-react");

var _Propulator = _interopRequireDefault(require("../../higher-order/Propulator"));

var _MobxView = _interopRequireDefault(require("../../higher-order/MobxView"));

var _Mouseflow = _interopRequireDefault(require("../../shared/components/Mouseflow"));

var _ContentItem = _interopRequireDefault(require("../../shared/components/cms/ContentItem"));

var _MarketingProductNavbar = _interopRequireDefault(require("../components/MarketingProductNavbar"));

var _QuoteSelector = _interopRequireWildcard(require("../components/QuoteSelector"));

var _MarketingPageContent = _interopRequireDefault(require("../components/MarketingPageContent"));

var _OnboardingCard = _interopRequireDefault(require("../components/products/OnboardingCard"));

var _MarketingCarousel = require("../components/MarketingCarousel");

var _MarketingHero = _interopRequireDefault(require("../components/MarketingHero"));

var _BulletPoint = _interopRequireDefault(require("../components/BulletPoint"));

var _LogoGarden = _interopRequireDefault(require("../components/LogoGarden"));

var _map = _interopRequireDefault(require("lodash/map"));

var _class;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FINCORE_BENEFITS = [{
  alt: "Learning center",
  className: "benefit-image",
  image: require("../assets/redesign2020/fincore/learning-center.png"),
  header: "Learning center",
  subheader: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Employees can increase their ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "financial knowledge")),
  description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Employees can ", /*#__PURE__*/_react.default.createElement("strong", null, "access interactive content modules"), " to help them gain the insight they need to make smart financial decisions.")
}, {
  alt: "Impact calculator",
  className: "benefit-image",
  image: require("../assets/redesign2020/fincore/impact-view.png"),
  header: "Impact calculators",
  subheader: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Employees can ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "see what\u2019s possible")),
  description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Employees can leverage these ", /*#__PURE__*/_react.default.createElement("strong", null, "personalized impact tools"), " to better understand their student loan debt and explore repayment strategies that might work best with their personal goals.")
}, {
  alt: "Student loan refinancing",
  className: "refinancing-tools-image",
  image: require("../assets/redesign2020/fincore/refinancing-scroll.png"),
  header: "Student loan refinancing",
  subheader: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Employees gain access to ", /*#__PURE__*/_react.default.createElement("span", {
    className: "highlighted"
  }, "leading student loan refinancing lenders")),
  description: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Employees can potentially lower their interest rates and monthly payments by accessing our ", /*#__PURE__*/_react.default.createElement("strong", null, "curated marketplace of student loan refinancing lenders."))
}];

var FinCoreBenefit = function FinCoreBenefit(_ref) {
  var image = _ref.image,
      alt = _ref.alt,
      className = _ref.className,
      header = _ref.header,
      subheader = _ref.subheader,
      description = _ref.description;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "benefit"
  }, /*#__PURE__*/_react.default.createElement("img", {
    alt: alt,
    src: image,
    className: className
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "benefit-body"
  }, /*#__PURE__*/_react.default.createElement("h3", {
    className: "benefit-body-header"
  }, header), /*#__PURE__*/_react.default.createElement("h2", {
    className: "benefit-body-subheader"
  }, subheader), /*#__PURE__*/_react.default.createElement("p", {
    className: "benefit-body-description"
  }, description)));
};

var FINCORE_BULLET_KEYS = ["fincoreDetailsBullet1", "fincoreDetailsBullet2", "fincoreDetailsBullet3"];

var Fincore = (0, _mobxReact.observer)(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(Fincore, _React$Component);

  var _super = _createSuper(Fincore);

  function Fincore() {
    _classCallCheck(this, Fincore);

    return _super.apply(this, arguments);
  }

  _createClass(Fincore, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      (0, _Mouseflow.default)();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_MarketingPageContent.default, {
        enableSubfooter: true,
        defaultProduct: _MarketingCarousel.MARKETING_CARDS.SLP
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "marketing-fincore"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "hero-wrapper"
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "background",
        className: "background-triangle",
        src: require("../assets/redesign2020/fincore/background-triangle.svg")
      }), /*#__PURE__*/_react.default.createElement(_MarketingHero.default, {
        desktopImage: require("../assets/redesign2020/fincore/desktop-hero.png"),
        tabletImage: require("../assets/redesign2020/fincore/tablet-hero.png"),
        mobileImage: require("../assets/redesign2020/fincore/mobile-hero.png"),
        logo: require("../assets/redesign2020/fincore-logo-darker.svg")
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "header-subtitle"
      }, "Financial"), /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted core"
      }, "Core"), /*#__PURE__*/_react.default.createElement("span", {
        className: "subtitle"
      }, "Give employees access to an all-in-one financial wellness platform that can help them ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "take control of their financial well-being"), "."))), /*#__PURE__*/_react.default.createElement(_MarketingProductNavbar.default, null), /*#__PURE__*/_react.default.createElement("div", {
        className: "fincore-details"
      }, /*#__PURE__*/_react.default.createElement("h1", {
        className: "fincore-details-header"
      }, "Help employees ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "improve their financial well-being"), "."), /*#__PURE__*/_react.default.createElement("div", {
        className: "fincore-body"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "fincore-body-text-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        contentKey: "fincoreDetailsBody",
        className: "fincore-body-text"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "fincore-list-wrapper"
      }, /*#__PURE__*/_react.default.createElement("ul", {
        className: "fincore-list"
      }, (0, _map.default)(FINCORE_BULLET_KEYS, function (contentKey) {
        return /*#__PURE__*/_react.default.createElement(_BulletPoint.default, {
          key: contentKey,
          contentKey: contentKey,
          className: "fincore-list-item"
        });
      }))))), /*#__PURE__*/_react.default.createElement("div", {
        className: "solutions-wrapper"
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "Financial Core Chevron",
        src: require("../assets/redesign2020/fincore/solutions-chevron.svg"),
        className: "solutions-image"
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "solutions"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "header"
      }, "FinancialCore ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "Solutions")), /*#__PURE__*/_react.default.createElement("div", {
        className: "solutions-benefits"
      }, (0, _map.default)(FINCORE_BENEFITS, function (_ref2) {
        var alt = _ref2.alt,
            className = _ref2.className,
            image = _ref2.image,
            header = _ref2.header,
            subheader = _ref2.subheader,
            description = _ref2.description;
        return /*#__PURE__*/_react.default.createElement(FinCoreBenefit, {
          alt: alt,
          className: className,
          image: image,
          header: header,
          subheader: subheader,
          description: description,
          key: alt
        });
      })))), /*#__PURE__*/_react.default.createElement("div", {
        className: "logo-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "logo-background"
      }), /*#__PURE__*/_react.default.createElement(_LogoGarden.default, null)), /*#__PURE__*/_react.default.createElement("div", {
        className: "lenders"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "lender-details"
      }, /*#__PURE__*/_react.default.createElement("h2", {
        className: "header"
      }, "Connecting employees with ", /*#__PURE__*/_react.default.createElement("span", {
        className: "highlighted"
      }, "leading lenders")), /*#__PURE__*/_react.default.createElement(_ContentItem.default, {
        tag: "p",
        className: "details",
        contentKey: "lenderDetails"
      })), /*#__PURE__*/_react.default.createElement("div", {
        className: "logos"
      }, /*#__PURE__*/_react.default.createElement("img", {
        alt: "Earnest",
        className: "earnest",
        src: require("../assets/redesign2020/fincore/earnest.png")
      }), /*#__PURE__*/_react.default.createElement("img", {
        alt: "LendKey",
        className: "lendkey",
        src: require("../assets/redesign2020/fincore/lendKey.png")
      }), /*#__PURE__*/_react.default.createElement("img", {
        alt: "Mefa",
        className: "mefa",
        src: require("../assets/redesign2020/fincore/mefa.png")
      }))), /*#__PURE__*/_react.default.createElement(_QuoteSelector.default, {
        defaultQuote: _QuoteSelector.QUOTE_CARDS.FINCORE
      }), /*#__PURE__*/_react.default.createElement(_OnboardingCard.default, null)));
    }
  }]);

  return Fincore;
}(_react.default.Component)) || _class;

var propulateView = (0, _Propulator.default)(Fincore, {});

var _default = (0, _MobxView.default)(propulateView, {});

exports.default = _default;